export enum GameProvider {
  bgaming = 'bgaming',
  netent = 'netent',
  pragmaticplay = 'pragmaticplay',
  nolimit = 'nolimit',
  evolution = 'evolution',

  acceptancetest = 'acceptancetest',
}
